'use client';

import { ScoreboardSp2 } from './scoreboard-sp2';
import { ScoreboardSp3 } from './scoreboard-sp3';
import { ScoreboardSp4 } from './scoreboard-sp4';
import { ScoreboardSp5 } from './scoreboard-sp5';
import { ScoreboardSp6 } from './scoreboard-sp6';
import { ScoreboardSp7 } from './scoreboard-sp7';
import { ScoreboardSp8 } from './scoreboard-sp8';
import { ScoreboardSp9 } from './scoreboard-sp9';
import { ScoreboardSp18 } from './scoreboard-sp18';
import { ScoreboardSp45 } from './scoreboard-sp45';
import { ScoreboardSp48 } from './scoreboard-sp48';
import { ScoreboardSp50 } from './scoreboard-sp50';
import {
	BaseballMatchModel,
	BasketballMatchModel,
	BadmintonMatchModel,
	BeachVolleyballMatchModel,
	CricketMatchModel,
	FootballMatchModel,
	IceHockeyMatchModel,
	MatchModelBase,
	SepakTakrawMatchModel,
	SnookerMatchModel,
	TableTennisMatchModel,
	TennisMatchModel,
	VolleyballMatchModel
} from '@nf/types/odds';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';

export type ScoreboardSportId = 2 | 3 | 4 | 5 | 6 | 7 | 8 | 18 | 45 | 50 | 9;
interface ScoreboardProps {
	sportId: ScoreboardSportId;
	matchModelData?: MatchModelBase
};

export const Scoreboard = ({ sportId, matchModelData }: ScoreboardProps) => {
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();
	const showServe = siteConfig?.EnableDisplayServe ?? false;
	return (
		<>
			{
				{
					2: <ScoreboardSp2 key={`${sportId}Scoreboard`} basketballMatchModel={matchModelData as BasketballMatchModel} />,
					3: <ScoreboardSp3 key={`${sportId}Scoreboard`} footballMatchModel={matchModelData as FootballMatchModel} />,
					4: <ScoreboardSp4 key={`${sportId}Scoreboard`} iceHockeyMatchModel={matchModelData as IceHockeyMatchModel} />,
					5: <ScoreboardSp5 key={`${sportId}Scoreboard`} tennisMatchModel={matchModelData as TennisMatchModel} showServe={showServe} />,
					6: <ScoreboardSp6 key={`${sportId}Scoreboard`} volleyballMatchModel={matchModelData as VolleyballMatchModel} showServe={showServe} />,
					7: <ScoreboardSp7 key={`${sportId}Scoreboard`} snookerMatchModel={matchModelData as SnookerMatchModel} />,
					8: <ScoreboardSp8 key={`${sportId}Scoreboard`} baseballMatchModel={matchModelData as BaseballMatchModel} />,
					9: <ScoreboardSp9 key={`${sportId}Scoreboard`} badmintonMatchModel={matchModelData as BadmintonMatchModel} showServe={showServe} />,
					18: <ScoreboardSp18 key={`${sportId}Scoreboard`} tableTennisMatchModel={matchModelData as TableTennisMatchModel} showServe={showServe} />,
					45: <ScoreboardSp45 key={`${sportId}Scoreboard`} beachVolleyballMatchModel={matchModelData as BeachVolleyballMatchModel} />,
					48: <ScoreboardSp48 key={`${sportId}Scoreboard`} sepakTakrawMatchModel={matchModelData as SepakTakrawMatchModel} />,
					50: <ScoreboardSp50 key={`${sportId}Scoreboard`} cricketMatchModel={matchModelData as CricketMatchModel} />,
				}[sportId]
			}
		</>
	);
};
